import { ThemeOptions } from '@mui/material/styles/createTheme';

export const lightModeOptions: ThemeOptions = {
    palette: {
        primary: {
            main: '#3f51b5',
        },
        secondary: {
            main: '#f50057',
        },
        background: {
          default: '#eeeeee',
          paper: '#f5f5f5',
        },
    },
    breakpoints: {
        values: {
            xs: 0,      // Extra small devices (smallest phones)
            sm: 360,    // Small devices (Galaxy S21 and similar ~360-384px)
            md: 414,    // Medium devices (iPhone Max and similar ~414-430px)
            lg: 600,    // Large devices (tablets and larger phones)
            xl: 1200,   // Extra large devices (desktop)
        },
    },
};
